import { useState } from 'react';
import { urlExp } from 'lib/expressions';
import { isValidUrl } from 'lib/isValidUrl';
import {
  BehanceIcon,
  DribbbleIcon,
  GitHubIcon,
  InstagramIcon,
  LinkedInIcon,
  MediumIcon,
  TwitterIcon,
  VimeoIcon,
} from 'components/common/svgIcons';
import styles from './SocialButton.module.css';

export type SocialPlatform =
  | 'behance'
  | 'dribbble'
  | 'github'
  | 'instagram'
  | 'linkedin'
  | 'medium'
  | 'twitter'
  | 'vimeo';

type SocialIconProps = {
  link: string;
  platform: SocialPlatform;
};

const SocialButton = ({ platform, link }: SocialIconProps) => {
  const [isHover, setIsHover] = useState<boolean>(false);
  const pathColor = isHover ? 'white' : '#666';
  const icons = {
    behance: {
      path: <BehanceIcon color={pathColor} />,
      url: 'https://www.behance.net/',
      color: '#0066FF',
    },
    dribbble: {
      path: <DribbbleIcon color={pathColor} />,
      url: 'https://dribbble.com/',
      color: '#FE378A',
    },
    github: {
      path: <GitHubIcon color={pathColor} />,
      url: 'https://github.com/',
      color: '#6677E0',
    },
    instagram: {
      path: <InstagramIcon color={pathColor} />,
      url: 'https://www.instagram.com/',
      color: '#F3006D',
    },
    linkedin: {
      path: <LinkedInIcon color={pathColor} />,
      url: 'https://www.linkedin.com/in/',
      color: '#0066C9',
    },
    medium: {
      path: <MediumIcon color={pathColor} />,
      url: 'https://medium.com/@',
      color: '#000000',
    },
    twitter: {
      path: <TwitterIcon color={pathColor} />,
      url: 'https://twitter.com/',
      color: '#00A2F9',
    },
    vimeo: {
      path: <VimeoIcon color={pathColor} />,
      url: 'https://vimeo.com/',
      color: '#00AFF5',
    },
  };

  function getUrl() {
    if (link.match(new RegExp(urlExp, 'g'))) {
      const url = link.match(/^[a-zA-Z]+:\/\//) ? link : `http://${link}`;
      // Links are user-entered and shown on public profiles, and
      // `javascript://example.com/%0a...` also matches urlExp.
      return isValidUrl(url) ? url : undefined;
    }
    if (link.charAt(0) === '@') {
      return icons[platform].url + link.substring(1);
    }
    return icons[platform].url + link;
  }

  return (
    <button
      className={styles.SocialButton}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      style={{ backgroundColor: isHover ? icons[platform].color : '#1b1b1b' }}
    >
      <a href={getUrl()} target="_blank" rel="noopener noreferrer">
        <svg width="32" height="32" viewBox="0 0 40 40">
          {icons[platform].path}
        </svg>
      </a>
    </button>
  );
};
export default SocialButton;
